import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { HOMEPAGE_SNAP_SECTIONS } from "../../utils";
import { Carousel } from "../Carousel";
import {
  CarouselTile,
  TileImageContainer,
  TileImage,
  TileContent,
} from "../CarouselTile";
import { Section, SectionTitle, SectionDescription } from "../Section";
import styles from "./ExploreFurtherSection.module.scss";
import { useExploreFurtherBanners } from "./hooks";
import { getBannerImageUrl } from "@/utils/banners/images";

export const ExploreFurtherSection = () => {
  const { t } = useI18nContext();
  const [, cn] = useModuleBEM(styles, "ExploreFurtherSection");

  const banners = useExploreFurtherBanners();

  if (banners.length === 0) {
    return null;
  }

  return (
    <Section
      id={HOMEPAGE_SNAP_SECTIONS.EXPLORE_FURTHER}
      className={cn("section-container")}
    >
      <SectionTitle as="h2">{t("home.exploreFurther.title")}</SectionTitle>
      <SectionDescription>
        {t("home.exploreFurther.description")}
      </SectionDescription>
      <div className={cn("carousel-container")}>
        <Carousel
          items={banners.map((banner) => {
            const imagePath = getBannerImageUrl(banner.imageFile);

            return (
              <a
                key={banner.name}
                href={banner.linkTarget}
                target="_blank"
                rel="noopener"
                referrerpolicy="no-referrer-when-downgrade"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <CarouselTile>
                  <TileImageContainer>
                    <TileImage src={imagePath} alt={banner.headerCopy} />
                  </TileImageContainer>
                  <TileContent>
                    <h3 className={cn("title")} data-carousel-title>
                      {banner.headerCopy}
                    </h3>
                    <p className={cn("description")}>{banner.subheaderCopy}</p>
                  </TileContent>
                </CarouselTile>
              </a>
            );
          })}
        />
      </div>
    </Section>
  );
};
